import React from 'react';
import {Text, TouchableOpacity, View, ViewStyle} from 'react-native';
import {noop} from 'lodash';

import BasicHeader from '/component/layout/BasicHeader';
import {withSafeArea} from '/provider/SafeAreaProvider';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {styles} from './Storybook.style';

import StorybookUIRoot from '/storybook';

// Define types for props
interface StorybookProps {
  storybookClose: () => void;
  tt: (keyPrefix: any, value: any) => void;
  safeAreaInsets: {top: number; bottom: number; left: number; right: number};
}

export const Storybook: React.FC<StorybookProps> = ({
  storybookClose = noop,
  tt = withTranslation.ttDefaultProp,
  safeAreaInsets = withSafeArea.safeAreaInsetsDefaultProp,
}: StorybookProps) => {
  const closeButtonContainerStyle: ViewStyle[] = [
    styles.storybookButtonContainer,
  ];

  closeButtonContainerStyle.push({
    bottom: safeAreaInsets?.bottom ?? 0,
  });

  return (
    <BasicHeader>
      <View style={styles.base}>
        <StorybookUIRoot />
        <TouchableOpacity
          style={closeButtonContainerStyle}
          onPress={storybookClose}>
          <Text style={styles.storybookButtonText}>
            {tt('hideStorybook', 'Hide Storybook')}
          </Text>
        </TouchableOpacity>
      </View>
    </BasicHeader>
  );
};

export default withHOC(
  withTranslation('screen.storybook'),
  withSafeArea,
)(Storybook);
